import round from 'lodash/round'

/**
 * 修复 number.toFixed 进位错误
 * 修复 Math.round & lodash.round 对负值的处理错误 -0.5 -> -0
 * @param number
 * @param precision
 * @return {*}
 */
export const toFixed = (number, precision = 0) => `${number >= 0 ? '' : '-'}${(round(Math.abs(number), precision)).toFixed(precision)}`

export const toLocalString = (number) => {
  const str = number.toString()
  const [integer, decimal] = str.split('.')
  return `${integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${decimal ? `.${decimal}` : ''}`
}
